/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsMasonry = {
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsMasonry = $.extend(this, window.PXUTheme.getSectionData($section));

    if ($('.gallery_placeholder').length && $('.gallery__wrap').length) {
      const $gallery = $('.gallery__wrap');
      $gallery.appendTo( '.gallery_placeholder' );
    }

    if ($('.grid__wrap').length) {
      // console.log('grid__wrap');
      const wrapper = '.grid__wrap > .shg-box-content',
            item = '.grid__item',
            sizer = '.grid__wrap > .shg-box-content > div:first-child',
            gutter = 5,
            percentPosition = true;
      window.addEventListener('load', window.PXUTheme.jsMasonry.replaceLazyload(item, wrapper, sizer, gutter, percentPosition));
    } else if ($('.gallery__wrap').length) {
      // console.log('gallery__wrap');
      const wrapper = '.gallery__wrap',
            item = '.gallery__item',
            sizer = '.gallery__sizer',
            gutter = this.gutter_size,
            percentPosition = this.percentPosition;
      window.addEventListener('load', window.PXUTheme.jsMasonry.runMasonry(item, wrapper, sizer, gutter, percentPosition));
    }
  },
  runMasonry: function(item, wrapper, sizer, gutter, percentPosition = true) {
    // Run Masonry function in utilities.js
    // console.log('Masonry Run')
    // window.PXUTheme.applyMasonry('.grid__item', 80, '.grid__wrap', '.grid__sizer');
    window.PXUTheme.applyMasonry(item, gutter, wrapper, sizer, percentPosition);
  },
  replaceLazyload: function(item, wrapper, sizer, gutter, percentPosition = true) {
    // console.log('run replaceLazyload');
    var images = document.getElementsByClassName('shogun-image');
    if (images && images.length) {
      // console.log('images && images.length = TRUE');
      for (var i = 0; i < images.length;i++) {
        var img = images[i];
        var src = img.getAttribute('src');
        var dataSrc = img.getAttribute('data-src');
        if (dataSrc) {
          if (!src) {
            // console.log('!src');
            img.setAttribute('src', dataSrc);
            img.classList.remove("shogun-lazyload");
            img.classList.remove("shogun-lazyloading");
            img.classList.add("lazyload");
          }
        }
      }
    }
    window.PXUTheme.jsMasonry.runMasonry(item, wrapper, sizer, gutter, percentPosition);
  },
  unload: function($section) {
    window.PXUTheme.applyMasonry.unload();
  }
}

/******/ })()
;